import React from 'react';
import { ERROR } from '../../../constants/routes';
import { EXCEPTION } from '../../../constants/errorStatuses';

class LoggerComponent extends React.Component {
  componentDidCatch(e, info) {
    this.props.logger.onError(e, {
      ...info,
      type: 'react'
    });
    window.location.href = `${ERROR}?errorReason=${EXCEPTION}`;
  }

  render() {
    return this.props.children;
  }
}

export default LoggerComponent;
